export const BRAND = {
  name: "All Concept Concrete",
  short: "All Concept",
  phone: process.env.REACT_APP_PHONE_DISPLAY || "0428 078 746",
  phoneHref: `tel:${process.env.REACT_APP_PHONE_E164 || "+61428078746"}`,
  phoneE164: process.env.REACT_APP_PHONE_E164 || "+61428078746",
  email: "allconceptconcrete@gmail.com",
  street: "22 Aruma Ave",
  suburb: "Burleigh Waters",
  region: "QLD",
  postcode: "4220",
  geo: { lat: -28.0804164, lng: 153.4433583 },
  mapsUrl: "https://maps.google.com/?cid=9299301887759182834",
  hours: "Mon–Fri 6:30am–5pm",
  licence: "QBCC Lic. 0000000",
};

export const IMG = {
  hero: "https://images.unsplash.com/photo-1772306814076-ff65f53ac438?crop=entropy&cs=srgb&fm=jpg&q=80&w=1800",
  polished: "https://images.unsplash.com/photo-1771531072574-af6ed6b954c0?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400",
  shine: "https://images.unsplash.com/photo-1772305336606-989a457ffbae?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400",
  epoxy: "https://images.unsplash.com/photo-1772305595483-6b058aff40f9?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400",
  prep: "https://images.unsplash.com/photo-1651195297119-afc97f14a40d?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400",
  site: "https://images.unsplash.com/photo-1694521787162-5373b598945c?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400",
  driveway: "https://images.unsplash.com/photo-1783125127143-d4e18726bab3?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400",
  garage: "https://images.unsplash.com/photo-1766801075605-8c036a5c4ec3?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400",
};

export const WORK_TYPES = [
  "Commercial epoxy flooring",
  "Commercial polished concrete",
  "Industrial flooring",
  "Surface prep / grind & seal",
  "Driveway & concrete resurfacing",
  "Pool area & garage flooring",
  "Other / not sure",
];

export type Service = {
  slug: string;
  title: string;
  workType: string;
  short: string;
  h1: string;
  metaTitle: string;
  metaDesc: string;
  intro: string;
  image: string;
  specs: { label: string; value: string }[];
  applications: string[];
  benefits: string[];
  process: string[];
  faqs: { q: string; a: string }[];
};

export const SERVICES: Service[] = [
  {
    slug: "commercial-epoxy-flooring",
    title: "Epoxy Flooring",
    workType: "Commercial epoxy flooring",
    short: "Chemical-resistant, seamless epoxy systems for forklift traffic, food-grade and hygiene-critical facilities.",
    h1: "Epoxy Flooring Gold Coast — Commercial & Industrial",
    metaTitle: "Epoxy Flooring Gold Coast | Commercial Epoxy Floors | All Concept Concrete",
    metaDesc: "Epoxy flooring Gold Coast — commercial and industrial epoxy floors by All Concept Concrete. HACCP-ready, slip-rated, forklift-tough systems installed by specialist crews. Call 0428 078 746.",
    intro: "Seamless, high-build epoxy systems engineered for warehouses, food production, workshops and commercial kitchens. We specify the system to your load, chemical and slip-resistance requirements — not a one-size-fits-all garage coating.",
    image: IMG.epoxy,
    specs: [
      { label: "System build", value: "0.5 – 6 mm" },
      { label: "Slip rating", value: "P3 – P5 (AS 4586)" },
      { label: "Solids content", value: "100% solids" },
      { label: "Return to service", value: "24 – 72 hrs" },
    ],
    applications: ["Warehouses & distribution", "Food & beverage production", "Commercial kitchens", "Automotive workshops", "Pharmaceutical & labs"],
    benefits: ["Seamless, hygienic & easy to clean", "Resistant to oils, acids & cleaning chemicals", "Line marking & safety zoning integrated", "Coved skirting for HACCP compliance"],
    process: ["Site inspection & moisture testing", "Diamond grind / shot-blast profiling", "Crack & joint repair", "Primer, body coat & broadcast", "UV-stable topcoat & line marking"],
    faqs: [
      { q: "Can you work around our operating hours?", a: "Yes. We stage works in zones and schedule night or weekend shifts so your facility keeps running." },
      { q: "Is your epoxy food-safe?", a: "We install HACCP-compatible systems with coved skirting suitable for food production and commercial kitchens." },
      { q: "How long does a commercial epoxy floor last?", a: "A correctly specified system typically delivers 10–15+ years under forklift traffic with routine maintenance." },
    ],
  },
  {
    slug: "commercial-polished-concrete",
    title: "Polished Concrete Flooring",
    workType: "Commercial polished concrete",
    short: "Mechanically polished and honed concrete for showrooms, offices, retail and architectural fitouts.",
    h1: "Polished Concrete Flooring Gold Coast",
    metaTitle: "Polished Concrete Flooring Gold Coast | All Concept Concrete",
    metaDesc: "Polished concrete flooring Gold Coast — architectural polished and honed concrete for showrooms, retail, offices and homes by All Concept Concrete. Specified finishes, slip-rated, delivered to program.",
    intro: "Mechanically ground and polished concrete delivered to architect specification — from honed matte to high-gloss, with nil, salt-and-pepper or full aggregate exposure. Built for high foot traffic and low lifetime maintenance.",
    image: IMG.polished,
    specs: [
      { label: "Gloss levels", value: "Matte – High gloss" },
      { label: "Exposure", value: "Nil / S&P / Full" },
      { label: "Slip rating", value: "P3+ achievable" },
      { label: "Densifier", value: "Lithium silicate" },
    ],
    applications: ["Car & boat showrooms", "Retail & shopping centres", "Corporate offices", "Hospitality venues", "Architectural residential towers"],
    benefits: ["Lowest lifetime maintenance cost", "Reflective — improves lighting efficiency", "Sample panels before full production", "Works to builder program & trades sequence"],
    process: ["Slab assessment & sample panel", "Progressive diamond grinding", "Grout & densify", "Polish to specified gloss", "Penetrating guard & handover"],
    faqs: [
      { q: "Can you match an architect's specification?", a: "Yes — we produce sample panels on site so the specifier signs off on exposure and gloss before production." },
      { q: "Do you work on new and existing slabs?", a: "Both. New slabs give the most consistent result; existing slabs are assessed for repairs and coverings first." },
    ],
  },
  {
    slug: "industrial-flooring",
    title: "Industrial Flooring Systems",
    workType: "Industrial flooring",
    short: "Polyurethane cement, heavy-duty toppings, ESD and thermal-shock systems for manufacturing and cold storage.",
    h1: "Industrial Flooring Gold Coast & Northern Corridor",
    metaTitle: "Industrial & Commercial Flooring Gold Coast | All Concept Concrete",
    metaDesc: "Heavy-duty industrial flooring for Yatala, Stapylton and Gold Coast facilities. Polyurethane cement, thermal shock, ESD and chemical-resistant systems.",
    intro: "When standard epoxy won't survive — hot wash-down, steel wheels, cold-room thermal cycling or static-sensitive production — we install heavy-duty urethane cement, mortar screeds and ESD systems engineered for the duty.",
    image: IMG.shine,
    specs: [
      { label: "Compressive strength", value: "Up to 85 MPa" },
      { label: "Thermal range", value: "-40°C to +120°C" },
      { label: "ESD option", value: "10⁶ – 10⁹ Ω" },
      { label: "Thickness", value: "4 – 9 mm" },
    ],
    applications: ["Cold storage & freezers", "Breweries & beverage", "Manufacturing plants", "Electronics & ESD zones", "Heavy plant maintenance"],
    benefits: ["Thermal shock & hot-water resistant", "Withstands impact & steel wheels", "Integrated drainage falls & bunding", "Engineered to load and duty"],
    process: ["Duty & load assessment", "Shot-blast & saw-cut anchoring", "Screed / falls to drains", "Urethane cement application", "Commissioning & maintenance plan"],
    faqs: [
      { q: "What's the difference between epoxy and PU cement?", a: "PU cement tolerates thermal shock, hot wash-down and moisture far better than epoxy, making it the default for food and cold-chain." },
      { q: "Can you fix falls to drains?", a: "Yes — we screed falls and integrate drainage as part of the flooring system." },
    ],
  },
  {
    slug: "concrete-surface-prep-grind-seal",
    title: "Surface Prep / Grind & Seal",
    workType: "Surface prep / grind & seal",
    short: "Dust-controlled diamond grinding, coating removal, levelling and clear protective sealers.",
    h1: "Concrete Surface Preparation, Grind & Seal Gold Coast",
    metaTitle: "Concrete Grind & Seal and Surface Prep Gold Coast | Commercial",
    metaDesc: "Commercial concrete grinding, coating removal, levelling and grind & seal on the Gold Coast. HEPA dust-controlled equipment, fast turnaround for builders.",
    intro: "Every coating fails or succeeds on its preparation. We profile, remove and level slabs for other trades and deliver cost-effective grind & seal finishes for warehouses, carparks and back-of-house areas.",
    image: IMG.prep,
    specs: [
      { label: "Dust control", value: "HEPA H13 extraction" },
      { label: "Profile", value: "CSP 2 – CSP 5" },
      { label: "Output", value: "Up to 500 m²/day" },
      { label: "Sealers", value: "Clear UV-stable" },
    ],
    applications: ["Pre-coating preparation", "Glue & coating removal", "Warehouse grind & seal", "Carparks & loading docks", "Trip-hazard & lip removal"],
    benefits: ["Silica-safe dust controlled grinding", "Fast turnaround for builder programs", "Budget-friendly protective finish", "Compliant SWMS on every job"],
    process: ["Moisture & hardness testing", "Remove existing coatings", "Diamond grind to profile", "Repair joints & cracks", "Apply densifier / sealer"],
    faqs: [
      { q: "Is grinding dusty?", a: "We run HEPA-extracted equipment that captures respirable silica at source, so other trades can keep working nearby." },
      { q: "Do you do prep for other flooring trades?", a: "Yes — we regularly prepare slabs for vinyl, carpet tile and other coating contractors." },
    ],
  },
  {
    slug: "driveway-concrete-resurfacing",
    title: "Driveway & Concrete Resurfacing",
    workType: "Driveway & concrete resurfacing",
    short: "Restore tired, stained or cracked driveways, paths and carparks with grind, repair and durable resurfacing systems.",
    h1: "Driveway & Concrete Resurfacing Gold Coast",
    metaTitle: "Driveway & Concrete Resurfacing Gold Coast | All Concept Concrete",
    metaDesc: "Concrete driveway resurfacing, crack repair and sealing on the Gold Coast and Northern Rivers. Commercial-grade systems for homes, strata and carparks. Call 0428 078 746.",
    intro: "Worn, oil-stained or cracked concrete doesn't need to be ripped out. We grind, repair and resurface driveways, paths, strata carparks and entries using the same commercial-grade preparation and coatings we install in warehouses — so the finish lasts.",
    image: IMG.driveway,
    specs: [
      { label: "Finishes", value: "Spray-on / honed / sealed" },
      { label: "Slip rating", value: "P4 – P5 outdoor" },
      { label: "Cure to foot traffic", value: "24 hrs" },
      { label: "Cure to vehicles", value: "72 hrs" },
    ],
    applications: ["Residential driveways", "Strata & body corporate carparks", "Paths & entries", "Commercial forecourts", "Boat ramps & wash bays"],
    benefits: ["No demolition or re-pour required", "Crack, spall & trip-hazard repair included", "UV-stable, anti-slip outdoor sealers", "Oil & tyre-mark resistant topcoats"],
    process: ["Site inspection & colour selection", "Pressure clean & diamond grind", "Crack, joint & spall repair", "Resurfacing coat / texture application", "Anti-slip UV-stable sealer"],
    faqs: [
      { q: "Will resurfacing hide cracks?", a: "We repair and fill cracks before resurfacing. Structural movement cracks may reappear, so we advise honestly on site before quoting." },
      { q: "How long until I can drive on it?", a: "Typically 72 hours for vehicles and 24 hours for foot traffic, depending on weather and system." },
      { q: "Do you resurface strata carparks?", a: "Yes — we work with body corporates and stage works so residents keep access." },
    ],
  },
  {
    slug: "pool-area-garage-flooring",
    title: "Pool Area & Garage Flooring",
    workType: "Pool area & garage flooring",
    short: "Slip-resistant pool surrounds and showroom-finish epoxy or flake garage floors built on commercial-grade prep.",
    h1: "Pool Area & Garage Flooring Gold Coast",
    metaTitle: "Pool Surround & Garage Epoxy Flooring Gold Coast | All Concept Concrete",
    metaDesc: "Non-slip pool surrounds and epoxy flake garage floors on the Gold Coast and Northern Rivers. Diamond-ground prep, UV-stable coatings. Call 0428 078 746.",
    intro: "Pool surrounds need grip and heat resistance; garages need a floor that shrugs off hot tyres, oil and chemicals. We bring commercial preparation and coating systems home — diamond grinding, moisture testing and UV-stable topcoats that don't peel or yellow.",
    image: IMG.garage,
    specs: [
      { label: "Pool slip rating", value: "P5 wet barefoot" },
      { label: "Garage system", value: "Epoxy + flake + PU" },
      { label: "Hot-tyre resistant", value: "Yes" },
      { label: "Return to use", value: "48 – 72 hrs" },
    ],
    applications: ["Pool surrounds & coping", "Residential garages", "Home workshops & sheds", "Alfresco & patio areas", "Car collector garages"],
    benefits: ["Barefoot-safe anti-slip textures", "Cool-touch, UV-stable outdoor finishes", "Flake & metallic garage finishes", "Chlorine, salt & chemical resistant"],
    process: ["Moisture & substrate testing", "Diamond grind (no acid etching)", "Repairs & joint detailing", "Base coat + flake / texture broadcast", "UV-stable polyaspartic or PU topcoat"],
    faqs: [
      { q: "Is the pool surround finish slippery when wet?", a: "No — we specify anti-slip textures rated for wet barefoot areas." },
      { q: "Will my garage floor peel from hot tyres?", a: "Hot-tyre pickup is usually caused by poor prep. We diamond grind and use high-performance topcoats designed to resist it." },
    ],
  },
];

export type Area = {
  slug: string;
  name: string;
  state?: string;
  postcode: string;
  h1: string;
  metaTitle: string;
  metaDesc: string;
  intro: string;
  industries: string[];
  precincts: string[];
  focus: string[];
  local: string;
};

export const AREAS: Area[] = [
  {
    slug: "yatala",
    name: "Yatala",
    postcode: "4207",
    h1: "Industrial & Epoxy Flooring Yatala",
    metaTitle: "Industrial & Epoxy Flooring Yatala | Warehouse Floors 4207",
    metaDesc: "Warehouse, logistics and food-grade flooring for Yatala Enterprise Area facilities. Epoxy, PU cement and grind & seal. Call 0428 078 746.",
    intro: "Yatala's enterprise area is the engine room of the northern Gold Coast — distribution centres, food manufacturers and transport depots that can't afford downtime. We install floors that survive forklift traffic and keep you running during works.",
    industries: ["Logistics & 3PL warehouses", "Food & beverage manufacturing", "Transport & fleet depots", "Building supply"],
    precincts: ["Yatala Enterprise Area", "Darlington Drive", "Stanmore Road", "Business Street"],
    focus: ["industrial-flooring", "commercial-epoxy-flooring", "concrete-surface-prep-grind-seal"],
    local: "15 minutes from our depot — fast site inspections and staged night works across the M1 corridor.",
  },
  {
    slug: "molendinar",
    name: "Molendinar",
    postcode: "4214",
    h1: "Commercial Epoxy & Industrial Flooring Molendinar",
    metaTitle: "Epoxy Flooring Molendinar | Commercial & Industrial Floors 4214",
    metaDesc: "Epoxy, polished concrete and industrial flooring for Molendinar manufacturing, trade and automotive businesses. Specialist commercial crews.",
    intro: "Molendinar's manufacturing and trade precinct needs floors that handle chemicals, hot-tyre pickup and constant traffic. We deliver workshop-grade epoxy and grind & seal systems with minimal disruption.",
    industries: ["Manufacturing & fabrication", "Automotive workshops", "Trade wholesale", "Food production"],
    precincts: ["Christine Avenue", "Hutchinson Street", "Lexington Road", "Strathaird Road"],
    focus: ["commercial-epoxy-flooring", "concrete-surface-prep-grind-seal", "industrial-flooring"],
    local: "Central Gold Coast access — weekend shutdown programs available for operating workshops.",
  },
  {
    slug: "nerang",
    name: "Nerang",
    postcode: "4211",
    h1: "Commercial Flooring Nerang | Epoxy & Polished Concrete",
    metaTitle: "Commercial Flooring Nerang | Epoxy & Polished Concrete 4211",
    metaDesc: "Commercial epoxy and polished concrete for Nerang showrooms, light industrial and fleet service centres. Request a quote or call 0428 078 746.",
    intro: "From light-industrial units off Spencer Road to showrooms on the Nerang-Broadbeach corridor, we deliver commercial floors that present well and stand up to daily trade use.",
    industries: ["Showrooms & trade counters", "Light industrial units", "Fleet service centres", "Gyms & recreation"],
    precincts: ["Spencer Road", "Lawrence Drive", "Nerang Business Park", "Weedons Road"],
    focus: ["commercial-polished-concrete", "commercial-epoxy-flooring", "concrete-surface-prep-grind-seal"],
    local: "Quick response across the Nerang and Hinterland gateway.",
  },
  {
    slug: "burleigh-heads",
    name: "Burleigh Heads",
    postcode: "4220",
    h1: "Polished Concrete & Commercial Flooring Burleigh Heads",
    metaTitle: "Polished Concrete Burleigh Heads | Commercial Fitout Flooring 4220",
    metaDesc: "Architectural polished concrete and epoxy for Burleigh Heads retail, hospitality, breweries and commercial fitouts. Specialist commercial crews.",
    intro: "Burleigh's West Burleigh industrial estate and coastal retail strip demand floors that look the part and survive hospitality traffic. We work with fitout builders and architects to deliver spec finishes on program.",
    industries: ["Breweries & distilleries", "Retail & hospitality fitouts", "Boutique showrooms", "Creative warehouses"],
    precincts: ["West Burleigh industrial estate", "Christine Avenue", "Gold Coast Highway strip", "Burleigh Junction"],
    focus: ["commercial-polished-concrete", "industrial-flooring", "commercial-epoxy-flooring"],
    local: "Experienced with tight-access coastal fitouts and after-hours retail works.",
  },
  {
    slug: "ormeau-stapylton",
    name: "Ormeau / Stapylton",
    postcode: "4208 / 4207",
    h1: "Warehouse & Industrial Flooring Ormeau and Stapylton",
    metaTitle: "Warehouse Flooring Ormeau & Stapylton | Industrial Epoxy 4208",
    metaDesc: "Large-format warehouse, cold storage and freight terminal flooring in Ormeau and Stapylton. PU cement, epoxy and grind & seal.",
    intro: "The Ormeau–Stapylton corridor is home to the region's biggest freight terminals and cold-chain facilities. We handle large-format floors with high-output equipment and multi-crew programs.",
    industries: ["Freight & logistics terminals", "Cold storage", "Heavy machinery workshops", "Construction supply"],
    precincts: ["Ormeau industrial estate", "Stapylton Jacobs Well Road", "Peachey Road", "Rudd Street"],
    focus: ["industrial-flooring", "concrete-surface-prep-grind-seal", "commercial-epoxy-flooring"],
    local: "High-output crews for 1,000 m²+ projects with staged handovers.",
  },
  {
    slug: "northern-rivers-nsw",
    name: "Northern Rivers NSW",
    state: "NSW",
    postcode: "2486 / 2478 / 2480",
    h1: "Commercial & Industrial Flooring Northern Rivers NSW",
    metaTitle: "Commercial Flooring Northern Rivers NSW | Tweed Heads, Ballina & Lismore",
    metaDesc: "Commercial epoxy, polished concrete and industrial flooring for Tweed Heads, Ballina and Lismore businesses. Gold Coast-based specialist crews. Call 0428 078 746.",
    intro: "Just over the border, the Northern Rivers has a fast-growing commercial base — from Tweed Heads trade estates to Ballina's industrial parks and Lismore's food and agricultural processing. Our Gold Coast crews service the region with the same specialist systems, documentation and program-driven delivery.",
    industries: ["Food & agricultural processing", "Trade & light industrial", "Retail & hospitality fitouts", "Healthcare & education facilities"],
    precincts: ["Tweed Heads South industrial estate", "Ballina Southern Cross Industrial Estate", "Lismore South industrial area", "Byron Bay Arts & Industry Estate"],
    focus: ["commercial-epoxy-flooring", "commercial-polished-concrete", "industrial-flooring"],
    local: "Regular crews across the border — Tweed Heads within 30 minutes, Ballina and Lismore scheduled as staged programs.",
  },
  ...([
    ["coomera", "Coomera", "4209", "Coomera's booming commercial corridor — Coomera Town Centre, the Foxwell Road industrial estate and new mixed-use developments — needs floors built for fast-tracked construction programs and heavy daily use.",
      ["Commercial construction & fitouts", "Light industrial & trade", "Retail & town-centre tenancies", "Residential driveways & garages"], ["Foxwell Road industrial estate", "Coomera Town Centre", "Dreamworld Parkway", "Upper Coomera"],
      ["commercial-epoxy-flooring", "commercial-polished-concrete", "driveway-concrete-resurfacing"], "Northern Gold Coast base — quick inspections along the M1 between Ormeau and Helensvale."],
    ["helensvale", "Helensvale", "4212", "Helensvale's business parks, retail precinct and established homes mean a mix of commercial and residential concrete work — from showroom polish to garage and driveway resurfacing.",
      ["Showrooms & trade counters", "Retail & medical tenancies", "Light industrial units", "Residential garages & pool areas"], ["Helensvale Business Park", "Westfield Helensvale precinct", "Siganto Drive", "Hope Island Road"],
      ["commercial-polished-concrete", "pool-area-garage-flooring", "commercial-epoxy-flooring"], "Central-north Gold Coast — after-hours retail works available."],
    ["southport", "Southport", "4215", "As the Gold Coast's CBD and health & knowledge precinct, Southport demands flooring that suits offices, clinics, hospitality and strata buildings — delivered around tenants and tight access.",
      ["Medical & healthcare", "Offices & education", "Hospitality fitouts", "Strata carparks"], ["Southport CBD", "Gold Coast Health & Knowledge Precinct", "Ferry Road", "Southport Central"],
      ["commercial-polished-concrete", "commercial-epoxy-flooring", "driveway-concrete-resurfacing"], "Experienced with CBD access, loading-dock bookings and night works."],
    ["robina", "Robina", "4226", "Robina's town centre, hospital precinct and commercial parks call for durable, presentable floors — plus resurfacing for the area's many strata complexes and family homes.",
      ["Retail & shopping centres", "Medical & allied health", "Commercial offices", "Strata & residential"], ["Robina Town Centre", "Robina hospital precinct", "Robina Commercial Park", "Bermuda Street"],
      ["commercial-polished-concrete", "driveway-concrete-resurfacing", "pool-area-garage-flooring"], "Southern Gold Coast crews — weekend works for occupied retail."],
    ["varsity-lakes", "Varsity Lakes", "4227", "Varsity Lakes' business precinct, Bond University surrounds and lakeside homes mean everything from office polish to slip-safe pool surrounds.",
      ["Offices & business parks", "Education facilities", "Gyms & fitness", "Lakeside homes & pool areas"], ["Varsity Central", "Market Square", "Lake Street business precinct", "Bond University surrounds"],
      ["commercial-polished-concrete", "pool-area-garage-flooring", "commercial-epoxy-flooring"], "Quick turnaround across Robina, Varsity and Burleigh Waters."],
    ["currumbin", "Currumbin", "4223", "Currumbin Waters' industrial estate and the coastal strip combine workshops, breweries and beachside homes — all needing floors that handle salt air, moisture and traffic.",
      ["Workshops & light industrial", "Breweries & hospitality", "Marine & surf industry", "Coastal homes, pools & driveways"], ["Currumbin Waters industrial estate", "Currumbin Creek Road", "Palm Beach", "Elanora"],
      ["industrial-flooring", "pool-area-garage-flooring", "driveway-concrete-resurfacing"], "Southern Gold Coast — UV and salt-resistant systems for coastal sites."],
    ["logan-crestmead", "Logan / Crestmead", "4132", "Crestmead, Berrinba and Loganholme form one of South East Queensland's biggest logistics hubs. We deliver large-format warehouse and industrial floors with high-output crews.",
      ["Logistics & distribution centres", "Manufacturing", "Cold storage", "Transport depots"], ["Crestmead Industrial Estate", "Berrinba", "Loganholme", "Meadowbrook"],
      ["industrial-flooring", "commercial-epoxy-flooring", "concrete-surface-prep-grind-seal"], "Northern corridor crews — staged programs for 1,000 m²+ warehouses."],
    ["tweed-heads", "Tweed Heads", "2485 / 2486", "Tweed Heads and Tweed Heads South sit right on the border, with a busy trade estate, clubs, aged care and coastal homes — all within easy reach of our Gold Coast crews.",
      ["Trade & light industrial", "Clubs & hospitality", "Aged care & healthcare", "Residential driveways & pools"], ["Tweed Heads South industrial estate", "Minjungbal Drive", "Banora Point", "Kingscliff"],
      ["commercial-epoxy-flooring", "driveway-concrete-resurfacing", "pool-area-garage-flooring"], "Just across the border — Tweed Heads within 30 minutes of our crews.", "NSW"],
  ] as [string, string, string, string, string[], string[], string[], string, string?][]).map(([slug, name, postcode, intro, industries, precincts, focus, local, state]) => ({
    slug, name, postcode, intro, industries, precincts, focus, local, state,
    h1: `Polished Concrete & Epoxy Flooring ${name}`,
    metaTitle: `Concrete Flooring ${name} | Epoxy, Polished Concrete & Resurfacing`,
    metaDesc: `Epoxy, polished concrete, industrial floors and concrete resurfacing in ${name} ${state || "QLD"} ${postcode}. Specialist crews. Call 0428 078 746.`,
  })),
];

export const LOCATIONS = [...AREAS.map((a) => a.name), "Other Gold Coast", "Logan / Brisbane South"];

export const CERTS = [
  { code: "AS 4586", label: "Slip resistance tested" },
  { code: "HACCP", label: "Food-grade systems" },
  { code: "QBCC", label: "Licensed contractor" },
  { code: "ISO 45001", label: "Safety systems aligned" },
  { code: "$20M", label: "Public liability" },
  { code: "10 YR", label: "System warranties" },
];

export const SECTORS = [
  { name: "Warehousing & Logistics", note: "Forklift-rated, line-marked" },
  { name: "Food & Beverage", note: "HACCP, coved, wash-down" },
  { name: "Automotive & Showrooms", note: "Hot-tyre resistant, high gloss" },
  { name: "Commercial Fitout", note: "Spec finishes, on program" },
  { name: "Manufacturing", note: "Chemical & impact resistant" },
  { name: "Cold Storage", note: "Thermal shock systems" },
];

export const STATS = [
  { value: "350K+", label: "m² installed" },
  { value: "15+", label: "years commercial" },
  { value: "48 hr", label: "quote turnaround" },
  { value: "0", label: "LTIs in 5 years" },
];

export const CASE_STUDIES = [
  {
    title: "3PL Distribution Centre",
    location: "Yatala",
    service: "Industrial flooring",
    image: IMG.hero,
    area: "4,200 m²",
    duration: "9 nights",
    challenge: "Live distribution centre with 24/7 forklift movements and no option for full shutdown.",
    solution: "Staged night-shift program in 6 zones with fast-cure urethane system and integrated line marking.",
    result: "Zero operating downtime; handed over two days ahead of program.",
  },
  {
    title: "Prestige Car Showroom",
    location: "Nerang",
    service: "Commercial polished concrete",
    image: IMG.polished,
    area: "1,150 m²",
    duration: "3 weeks",
    challenge: "Architect-specified high-gloss, salt-and-pepper finish over a new slab within a tight builder program.",
    solution: "Sample panels signed off in week one; progressive grind sequenced around glazing and joinery trades.",
    result: "Signed off first inspection; client has since engaged us on two further dealerships.",
  },
  {
    title: "Food Production Facility",
    location: "Molendinar",
    service: "Commercial epoxy flooring",
    image: IMG.epoxy,
    area: "680 m²",
    duration: "5 days",
    challenge: "Failing coating, ponding water and HACCP audit non-conformance.",
    solution: "Full removal, re-screeded falls to drains, PU cement with 100 mm coved skirting.",
    result: "Passed audit with no floor-related findings.",
  },
];

export const TESTIMONIALS = [
  { quote: "They work like a builder thinks — program, SWMS, sample panels, handover docs. No chasing required.", name: "Daniel R.", role: "Project Manager, Commercial Builder" },
  { quote: "We couldn't stop the warehouse. All Concept staged it across nights and we never missed a dispatch.", name: "Leanne K.", role: "Operations Manager, 3PL Yatala" },
  { quote: "Finally a flooring contractor who reads the spec. The polished finish matched our sample exactly.", name: "Marcus T.", role: "Architect, Burleigh Heads" },
];

export const GALLERY = [
  { src: IMG.hero, title: "Warehouse epoxy system", sector: "Warehouse" },
  { src: IMG.polished, title: "Showroom polished concrete", sector: "Showroom" },
  { src: IMG.shine, title: "High-gloss industrial floor", sector: "Industrial" },
  { src: IMG.epoxy, title: "Epoxy application", sector: "Food & Beverage" },
  { src: IMG.prep, title: "Diamond grinding prep", sector: "Surface Prep" },
  { src: IMG.site, title: "Commercial slab preparation", sector: "Commercial Fitout" },
];

export const COMPLIANCE = [
  { title: "Slip resistance (AS 4586-2013)", body: "Systems tested and specified to P-ratings for wet and dry areas, with certification available for specifiers." },
  { title: "Food safety (HACCP)", body: "Seamless, non-porous systems with coved skirting and falls to drains for food and beverage facilities." },
  { title: "Low-VOC & silica safe", body: "Low-odour systems for occupied buildings and HEPA-extracted grinding to manage respirable crystalline silica." },
  { title: "Documentation", body: "SWMS, ITPs, product data sheets, test results and warranties delivered as a handover pack." },
];

export const KEYWORDS = ["Polished concrete", "Polished concrete flooring", "Epoxy flooring", "Commercial flooring", "Industrial flooring", "Concrete grind and seal", "Concrete resurfacing", "Garage epoxy flooring"];

export const ABOUT = "All Concept Concrete is a Gold Coast concrete flooring contractor specialising in polished concrete, polished concrete flooring, epoxy flooring and commercial flooring. Based in Burleigh Waters, the team installs polished concrete, epoxy and industrial floor systems, concrete grind and seal, driveway resurfacing, pool surrounds and garage floors for builders, warehouses, showrooms, retail, hospitality and homeowners across the Gold Coast, Logan and the Northern Rivers NSW.";

export const HOME_FAQS = [
  { q: "What does All Concept Concrete do?", a: ABOUT },
  { q: "Do you install polished concrete flooring on the Gold Coast?", a: "Yes. We install mechanically polished and honed concrete flooring — from matte to high gloss, with nil, salt-and-pepper or full aggregate exposure — for showrooms, retail, offices, hospitality and homes across the Gold Coast." },
  { q: "What is the difference between polished concrete and epoxy flooring?", a: "Polished concrete is the slab itself, ground and polished with diamonds and densified — very durable and low maintenance. Epoxy flooring is a seamless resin coating applied over the concrete — ideal where you need chemical resistance, hygiene, colour, line marking or slip ratings, such as warehouses, food production and garages." },
  { q: "Do you do commercial flooring for builders and warehouses?", a: "Yes. Commercial and industrial flooring is our core work — epoxy, polished concrete, polyurethane cement and grind and seal for builders, fitout contractors, warehouses, factories and showrooms, with SWMS, sample panels and staged night or weekend works." },
  { q: "Which areas do you service?", a: "The whole Gold Coast including Burleigh Heads, Robina, Varsity Lakes, Southport, Helensvale, Coomera, Nerang, Molendinar, Yatala and Ormeau, plus Logan and the Northern Rivers NSW including Tweed Heads, Ballina and Lismore." },
  { q: "How do I get a quote?", a: `Call ${BRAND.phone} or send the online quote form with your site address and type of work. We reply within one business day and offer free site inspections.` },
];
